import { toast, type ToastApi } from "@/lib/toast";

/**
 * Ergonomischer Zugriff auf das Toast-API innerhalb von React-Komponenten.
 * Gibt die stabile, modulweite `toast`-Instanz zurück – es ist kein Provider
 * nötig, lediglich ein einmal gerendertes `<ToastViewport />` im App-Root.
 */
export function useToast(): ToastApi {
  return toast;
}
